import type { ApiOwnRsvp } from '#/modules/listing/events/api/types/ApiRsvpResponse';
import { postJson } from '#/utils/http/postJson';

type ApiResponse = {
  ownRsvp: ApiOwnRsvp;
};

export function listingApiCancelEventRsvp(
  eventId: string,
  rsvpId: string,
): Promise<ApiResponse> {
  return postJson<ApiResponse>(`/data/website/events/${eventId}/rsvp/cancel`, {
    rsvpId,
  });
}
